(function () {
  // Mobile menu
  document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var nav = document.getElementById(btn.getAttribute('aria-controls'));
      if (!nav) return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      nav.setAttribute('data-open', String(!open));
    });
  });

  // Product: offer cards, gallery, sticky bar
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var dataEl = root.querySelector('[data-product-json]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var idInput = root.querySelector('[name="id"]');
    var priceEls = document.querySelectorAll('[data-product-price]');
    var submit = root.querySelector('[data-add-to-cart]');
    var mainImg = document.getElementById('ProductMainImage');

    function select(id) {
      var v = variants.find(function (x) { return String(x.id) === String(id); });
      if (!v) return;
      idInput.value = v.id;
      priceEls.forEach(function (el) { el.textContent = v.price_formatted; });
      document.querySelectorAll('[data-offer-qty]').forEach(function (el) { el.textContent = v.title; });
      if (submit) {
        submit.disabled = !v.available;
        submit.querySelector('[data-label]').textContent = v.available ? submit.getAttribute('data-label-available') : submit.getAttribute('data-label-soldout');
      }
      if (v.featured_image && mainImg) {
        mainImg.src = v.featured_image;
        mainImg.removeAttribute('srcset');
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }

    root.querySelectorAll('[name="offer"]').forEach(function (radio) {
      radio.addEventListener('change', function () { select(radio.value); });
    });

    root.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.src = thumb.getAttribute('data-src');
        mainImg.removeAttribute('srcset');
        root.querySelectorAll('[data-thumb]').forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
        thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      });
    });

    var stickyAdd = document.querySelector('[data-sticky-add]');
    var form = document.getElementById('ProductForm');
    if (stickyAdd && form && submit) {
      stickyAdd.addEventListener('click', function (e) {
        e.preventDefault();
        if (submit.disabled) return;
        if (form.requestSubmit) form.requestSubmit(submit); else submit.click();
      });
    }

    var sticky = document.querySelector('[data-sticky-atc]');
    if (sticky && submit && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.setAttribute('data-visible', String(!e.isIntersecting && e.boundingClientRect.top < 0));
      }).observe(submit);
    }
  });

  // Delivery timeline dates
  document.querySelectorAll('[data-delivery]').forEach(function (el) {
    var fmt = new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'short' });
    function add(n) { var d = new Date(); d.setDate(d.getDate() + n); return d; }
    function range(a, b) {
      var da = add(a), db = add(b);
      if (da.getMonth() === db.getMonth()) return da.getDate() + ' – ' + fmt.format(db);
      return fmt.format(da) + ' – ' + fmt.format(db);
    }
    var n = function (k) { return parseInt(el.getAttribute(k), 10) || 0; };
    var steps = el.querySelectorAll('[data-delivery-step]');
    if (steps[0]) steps[0].textContent = fmt.format(new Date());
    if (steps[1]) steps[1].textContent = range(n('data-ship-min'), n('data-ship-max'));
    if (steps[2]) steps[2].textContent = range(n('data-deliver-min'), n('data-deliver-max'));
  });
})();
